import { isAxiosError } from 'axios'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let triggerToast: any = null

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function injectAddToast(addToast: any) {
  triggerToast = addToast
}

export const apiErrorHandler = async <T>(
  promise: Promise<T>,
  { toast } = { toast: true },
) => {
  try {
    return await promise
  } catch (err) {
    if (toast && isAxiosError(err)) {
      triggerToast({
        title: String(err.response?.data?.message || err.response?.data || err),
        body: [
          `Server responded with status ${err.response?.status}`,
          err.response?.statusText,
        ]
          .filter(Boolean)
          .join(' - '),
        type: 'fail',
      })
    }

    throw err
  }
}
